import { EventEmitter } from 'events';
import { UniPassPopupSDK } from '@unipasswallet/popup-sdk';
import { utils, providers } from 'ethers';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// supported chain ids, do not change
// ethereum
var ETHEREUM_MAINNET = 1;
var ETHEREUM_GOERLI = 5;
// polygon
var POLYGON_MAINNET = 137;
var POLYGON_MUMBAI = 80001;
// bsc
var BSC_MAINNET = 56;
var BSC_TESTNET = 97;
// rangers
var RANGERS_MAINNET = 2025;
var RANGERS_ROBIN = 9527;
// scroll testnet only
var SCROLL_TESTNET = 534354;
// arbitrum
var ARBITRUM_TESTNET = 421613;
var ARBITRUM_MAINNET = 42161;
// avax
var AVALANCHE_TESTNET = 43113;
var AVALANCHE_MAINNET = 43114;
// kcc
var KCC_TESTNET = 322;
var KCC_MAINNET = 321;
// okc
var OKC_TESTNET = 65;
var OKC_MAINNET = 66;
// platon
var PLATON_TESTNET = 2206132;
var PLATON_MAINNET = 210425;
var SUPPORTED_CHAIN_ID = [ETHEREUM_MAINNET, ETHEREUM_GOERLI, POLYGON_MAINNET, POLYGON_MUMBAI, BSC_MAINNET, BSC_TESTNET, RANGERS_MAINNET, RANGERS_ROBIN, SCROLL_TESTNET, ARBITRUM_TESTNET, ARBITRUM_MAINNET, AVALANCHE_TESTNET, AVALANCHE_MAINNET, KCC_TESTNET, KCC_MAINNET, OKC_TESTNET, OKC_MAINNET, PLATON_TESTNET];
var SUPPORTED_MAINNET_CHAIN_ID = [ETHEREUM_MAINNET, POLYGON_MAINNET, BSC_MAINNET, RANGERS_MAINNET, ARBITRUM_MAINNET, AVALANCHE_MAINNET, KCC_MAINNET, OKC_MAINNET, PLATON_MAINNET];
var SUPPORTED_TESTNET_CHAIN_ID = [ETHEREUM_GOERLI, POLYGON_MUMBAI, BSC_TESTNET, RANGERS_ROBIN, SCROLL_TESTNET, ARBITRUM_TESTNET, AVALANCHE_TESTNET, KCC_TESTNET, OKC_MAINNET, PLATON_TESTNET];
var getChainNameByChainId = function getChainNameByChainId(id) {
  switch (Number(id)) {
    case ETHEREUM_MAINNET:
    case ETHEREUM_GOERLI:
      return 'eth';
    case POLYGON_MAINNET:
    case POLYGON_MUMBAI:
      return 'polygon';
    case BSC_MAINNET:
    case BSC_TESTNET:
      return 'bsc';
    case RANGERS_MAINNET:
    case RANGERS_ROBIN:
      return 'rangers';
    case SCROLL_TESTNET:
      return 'scroll';
    case ARBITRUM_TESTNET:
    case ARBITRUM_MAINNET:
      return 'arbitrum';
    case AVALANCHE_TESTNET:
    case AVALANCHE_MAINNET:
      return 'avalanche';
    case KCC_TESTNET:
    case KCC_MAINNET:
      return 'kcc';
    case OKC_TESTNET:
    case OKC_MAINNET:
      return 'okc';
    case PLATON_TESTNET:
    case PLATON_MAINNET:
      return 'platon';
    default:
      return 'polygon';
  }
};
var getENVByChainId = function getENVByChainId(id) {
  switch (Number(id)) {
    case ETHEREUM_MAINNET:
    case POLYGON_MAINNET:
    case BSC_MAINNET:
    case RANGERS_MAINNET:
    case ARBITRUM_MAINNET:
    case AVALANCHE_MAINNET:
    case KCC_MAINNET:
    case PLATON_MAINNET:
    case OKC_MAINNET:
      return 'prod';
    case ETHEREUM_GOERLI:
    case POLYGON_MUMBAI:
    case BSC_TESTNET:
    case RANGERS_ROBIN:
    case SCROLL_TESTNET:
    case ARBITRUM_TESTNET:
    case AVALANCHE_TESTNET:
    case KCC_TESTNET:
    case PLATON_TESTNET:
    case OKC_TESTNET:
      return 'test';
    default:
      return 'test';
  }
};
var getRPCByChainId = function getRPCByChainId(id, rpcUrls) {
  var _rpcUrls$mainnet, _rpcUrls, _rpcUrls$polygon, _rpcUrls2, _rpcUrls$bscMainnet, _rpcUrls3, _rpcUrls$rangersMainn, _rpcUrls4, _rpcUrls$arbitrumMain, _rpcUrls5, _rpcUrls$avalancheMai, _rpcUrls6, _rpcUrls$kccMainnet, _rpcUrls7, _rpcUrls$platonMainne, _rpcUrls8, _rpcUrls$platonMainne2, _rpcUrls9, _rpcUrls$goerli, _rpcUrls10, _rpcUrls$polygonMumba, _rpcUrls11, _rpcUrls$bscTestnet, _rpcUrls12, _rpcUrls$rangersRobin, _rpcUrls13, _rpcUrls$scrollTestne, _rpcUrls14, _rpcUrls$arbitrumTest, _rpcUrls15, _rpcUrls$avalancheTes, _rpcUrls16, _rpcUrls$kccTestnet, _rpcUrls17, _rpcUrls$platonTestne, _rpcUrls18, _rpcUrls$okcTestnet, _rpcUrls19;
  rpcUrls = rpcUrls || {};
  switch (Number(id)) {
    case ETHEREUM_MAINNET:
      return (_rpcUrls$mainnet = (_rpcUrls = rpcUrls) == null ? void 0 : _rpcUrls.mainnet) != null ? _rpcUrls$mainnet : 'https://node.wallet.unipass.id/eth-mainnet';
    case POLYGON_MAINNET:
      return (_rpcUrls$polygon = (_rpcUrls2 = rpcUrls) == null ? void 0 : _rpcUrls2.polygon) != null ? _rpcUrls$polygon : 'https://node.wallet.unipass.id/polygon-mainnet';
    case BSC_MAINNET:
      return (_rpcUrls$bscMainnet = (_rpcUrls3 = rpcUrls) == null ? void 0 : _rpcUrls3.bscMainnet) != null ? _rpcUrls$bscMainnet : 'https://node.wallet.unipass.id/bsc-mainnet';
    case RANGERS_MAINNET:
      return (_rpcUrls$rangersMainn = (_rpcUrls4 = rpcUrls) == null ? void 0 : _rpcUrls4.rangersMainnet) != null ? _rpcUrls$rangersMainn : 'https://node.wallet.unipass.id/rangers-mainnet';
    case ARBITRUM_MAINNET:
      return (_rpcUrls$arbitrumMain = (_rpcUrls5 = rpcUrls) == null ? void 0 : _rpcUrls5.arbitrumMainnet) != null ? _rpcUrls$arbitrumMain : 'https://node.wallet.unipass.id/arbitrum-mainnet';
    case AVALANCHE_MAINNET:
      return (_rpcUrls$avalancheMai = (_rpcUrls6 = rpcUrls) == null ? void 0 : _rpcUrls6.avalancheMainnet) != null ? _rpcUrls$avalancheMai : 'https://node.wallet.unipass.id/avalanche-mainnet';
    case KCC_MAINNET:
      return (_rpcUrls$kccMainnet = (_rpcUrls7 = rpcUrls) == null ? void 0 : _rpcUrls7.kccMainnet) != null ? _rpcUrls$kccMainnet : 'https://node.wallet.unipass.id/kcc-mainnet';
    case PLATON_MAINNET:
      return (_rpcUrls$platonMainne = (_rpcUrls8 = rpcUrls) == null ? void 0 : _rpcUrls8.platonMainnet) != null ? _rpcUrls$platonMainne : 'https://node.wallet.unipass.id/platon-mainnet';
    case OKC_MAINNET:
      return (_rpcUrls$platonMainne2 = (_rpcUrls9 = rpcUrls) == null ? void 0 : _rpcUrls9.platonMainnet) != null ? _rpcUrls$platonMainne2 : 'https://node.wallet.unipass.id/okc-mainnet';
    case ETHEREUM_GOERLI:
      return (_rpcUrls$goerli = (_rpcUrls10 = rpcUrls) == null ? void 0 : _rpcUrls10.goerli) != null ? _rpcUrls$goerli : 'https://node.wallet.unipass.id/eth-goerli';
    case POLYGON_MUMBAI:
      return (_rpcUrls$polygonMumba = (_rpcUrls11 = rpcUrls) == null ? void 0 : _rpcUrls11.polygonMumbai) != null ? _rpcUrls$polygonMumba : 'https://node.wallet.unipass.id/polygon-mumbai';
    case BSC_TESTNET:
      return (_rpcUrls$bscTestnet = (_rpcUrls12 = rpcUrls) == null ? void 0 : _rpcUrls12.bscTestnet) != null ? _rpcUrls$bscTestnet : 'https://node.wallet.unipass.id/bsc-testnet';
    case RANGERS_ROBIN:
      return (_rpcUrls$rangersRobin = (_rpcUrls13 = rpcUrls) == null ? void 0 : _rpcUrls13.rangersRobin) != null ? _rpcUrls$rangersRobin : 'https://node.wallet.unipass.id/rangers-robin';
    case SCROLL_TESTNET:
      return (_rpcUrls$scrollTestne = (_rpcUrls14 = rpcUrls) == null ? void 0 : _rpcUrls14.scrollTestnet) != null ? _rpcUrls$scrollTestne : 'https://node.wallet.unipass.id/scroll-testnet';
    case ARBITRUM_TESTNET:
      return (_rpcUrls$arbitrumTest = (_rpcUrls15 = rpcUrls) == null ? void 0 : _rpcUrls15.arbitrumTestnet) != null ? _rpcUrls$arbitrumTest : 'https://node.wallet.unipass.id/arbitrum-testnet';
    case AVALANCHE_TESTNET:
      return (_rpcUrls$avalancheTes = (_rpcUrls16 = rpcUrls) == null ? void 0 : _rpcUrls16.avalancheTestnet) != null ? _rpcUrls$avalancheTes : 'https://node.wallet.unipass.id/avalanche-testnet';
    case KCC_TESTNET:
      return (_rpcUrls$kccTestnet = (_rpcUrls17 = rpcUrls) == null ? void 0 : _rpcUrls17.kccTestnet) != null ? _rpcUrls$kccTestnet : 'https://node.wallet.unipass.id/kcc-testnet';
    case PLATON_TESTNET:
      return (_rpcUrls$platonTestne = (_rpcUrls18 = rpcUrls) == null ? void 0 : _rpcUrls18.platonTestnet) != null ? _rpcUrls$platonTestne : 'https://node.wallet.unipass.id/platon-testnet';
    case OKC_TESTNET:
      return (_rpcUrls$okcTestnet = (_rpcUrls19 = rpcUrls) == null ? void 0 : _rpcUrls19.okcTestnet) != null ? _rpcUrls$okcTestnet : 'https://node.wallet.unipass.id/okc-testnet';
    default:
      return 'https://node.wallet.unipass.id/polygon-mumbai';
  }
};
var isCorrectChainId = function isCorrectChainId(currentChainId, chainId) {
  if (SUPPORTED_MAINNET_CHAIN_ID.includes(currentChainId)) {
    return SUPPORTED_MAINNET_CHAIN_ID.includes(chainId);
  }
  if (SUPPORTED_TESTNET_CHAIN_ID.includes(currentChainId)) {
    return SUPPORTED_TESTNET_CHAIN_ID.includes(chainId);
  }
  return false;
};
function convertHexToUtf8(value) {
  if (utils.isHexString(value)) {
    return utils.toUtf8String(value);
  }
  return value;
}
function getSignParamsMessage(params) {
  var message = params.filter(function (p) {
    return !utils.isAddress(p);
  })[0];
  return convertHexToUtf8(message);
}
function getSignTypedDataParamsData(params) {
  var data = params.filter(function (p) {
    return !utils.isAddress(p);
  })[0];
  if (typeof data === 'string') {
    return JSON.parse(data);
  }
  return data;
}

var JsonRpcProvider = /*#__PURE__*/function () {
  function JsonRpcProvider(chainId, returnEmail, configurations, rpcUrls, appSetting) {
    var _this = this;
    this.returnEmail = false;
    this.configurations = {
      onAuthChain: true
    };
    this.updateUpWalletConfig = function (chainId) {
      var nodeRPC = getRPCByChainId(chainId, _this.rpcUrls);
      _this.upWallet.updateConfig({
        chainType: getChainNameByChainId(chainId),
        nodeRPC: nodeRPC,
        appSettings: {
          chain: getChainNameByChainId(chainId)
        }
      });
      _this.chainId = chainId;
      _this.http = new providers.JsonRpcProvider(nodeRPC);
    };
    this.appSetting = appSetting;
    this.returnEmail = returnEmail;
    if (configurations) {
      this.configurations = _extends({}, this.configurations, configurations);
    }
    this.chainId = chainId;
    this.rpcUrls = rpcUrls;
    var nodeRPC = getRPCByChainId(chainId, rpcUrls);
    this.upWallet = new UniPassPopupSDK({
      env: getENVByChainId(chainId),
      chainType: getChainNameByChainId(chainId),
      appSettings: _extends({}, this.appSetting, {
        chain: getChainNameByChainId(chainId)
      }),
      nodeRPC: nodeRPC,
      storageType: 'sessionStorage',
      walletUrl: this.configurations.walletUrl
    });
    this.http = new providers.JsonRpcProvider(nodeRPC);
  }
  var _proto = JsonRpcProvider.prototype;
  _proto.connect = /*#__PURE__*/function () {
    var _connect = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var account;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            account = this.upWallet.getAccount();
            if (!account) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", account);
          case 3:
            _context.next = 5;
            return this.upWallet.login({
              email: this.returnEmail
            });
          case 5:
            return _context.abrupt("return", _context.sent);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function connect() {
      return _connect.apply(this, arguments);
    }
    return connect;
  }();
  _proto.disconnect = /*#__PURE__*/function () {
    var _disconnect = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.upWallet.logout();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function disconnect() {
      return _disconnect.apply(this, arguments);
    }
    return disconnect;
  }();
  _proto.request = /*#__PURE__*/function () {
    var _request2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_request) {
      var _params;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!_request.method.startsWith('eth_signTypedData')) {
              _context3.next = 6;
              break;
            }
            _context3.next = 3;
            return this.upWallet.signTypedData(getSignTypedDataParamsData(_request.params), {
              onAuthChain: this.configurations.onAuthChain
            });
          case 3:
            return _context3.abrupt("return", _context3.sent);
          case 6:
            if (!(_request.method === 'personal_sign')) {
              _context3.next = 12;
              break;
            }
            _context3.next = 9;
            return this.upWallet.signMessage(getSignParamsMessage(_request.params), {
              isEIP191Prefix: true,
              onAuthChain: this.configurations.onAuthChain
            });
          case 9:
            return _context3.abrupt("return", _context3.sent);
          case 12:
            if (!(_request.method === 'eth_sendTransaction')) {
              _context3.next = 21;
              break;
            }
            _params = _request != null && _request.params && Array.isArray(_request == null ? void 0 : _request.params) && _request != null && _request.params[0] ? _request == null ? void 0 : _request.params[0] : undefined;
            if (!_params) {
              _context3.next = 18;
              break;
            }
            _context3.next = 17;
            return this.upWallet.sendTransaction(_params);
          case 17:
            return _context3.abrupt("return", _context3.sent);
          case 18:
            throw new Error('eth_sendTransaction error');
          case 21:
            _context3.next = 23;
            return this.http.send(_request.method, _request.params || []);
          case 23:
            return _context3.abrupt("return", _context3.sent);
          case 24:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function request(_x) {
      return _request2.apply(this, arguments);
    }
    return request;
  }();
  return JsonRpcProvider;
}();

var UniPassProvider = /*#__PURE__*/function () {
  function UniPassProvider(options) {
    this.account = undefined;
    this.events = new EventEmitter();
    if (!SUPPORTED_CHAIN_ID.includes(options.chainId)) {
      throw new Error("Not supported chain id: " + options.chainId);
    }
    this.chainId = options.chainId;
    this.signer = new JsonRpcProvider(this.chainId, options.returnEmail, options.configurations, options.rpcUrls, options.appSettings);
  }
  var _proto = UniPassProvider.prototype;
  _proto.request = /*#__PURE__*/function () {
    var _request = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      var _this$account, _this$account2, _params$chainId;
      var account, _params, chainId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = args.method;
            _context.next = _context.t0 === 'eth_requestAccounts' ? 3 : _context.t0 === 'eth_accounts' ? 7 : _context.t0 === 'eth_chainId' ? 8 : _context.t0 === 'wallet_switchEthereumChain' ? 9 : 19;
            break;
          case 3:
            _context.next = 5;
            return this.connect();
          case 5:
            account = _context.sent;
            return _context.abrupt("return", account);
          case 7:
            return _context.abrupt("return", (_this$account = this.account) != null && _this$account.address ? [(_this$account2 = this.account) == null ? void 0 : _this$account2.address] : []);
          case 8:
            return _context.abrupt("return", this.chainId);
          case 9:
            _params = args != null && args.params && Array.isArray(args == null ? void 0 : args.params) && args != null && args.params[0] ? args == null ? void 0 : args.params[0] : undefined;
            chainId = typeof (_params == null ? void 0 : _params.chainId) === 'string' && _params != null && (_params$chainId = _params.chainId) != null && _params$chainId.startsWith('0x') ? parseInt(_params == null ? void 0 : _params.chainId, 16) : _params == null ? void 0 : _params.chainId;
            if (SUPPORTED_CHAIN_ID.includes(chainId)) {
              _context.next = 13;
              break;
            }
            throw new Error("chainId " + chainId + " not supported");
          case 13:
            if (isCorrectChainId(this.chainId, chainId)) {
              _context.next = 15;
              break;
            }
            throw new Error('mainnet and testnet cannot be switched to each other');
          case 15:
            this.signer.updateUpWalletConfig(chainId);
            this.chainId = chainId;
            this.events.emit('chainChanged', _params == null ? void 0 : _params.chainId);
            return _context.abrupt("return");
          case 19:
            return _context.abrupt("break", 20);
          case 20:
            _context.next = 22;
            return this.signer.request(args);
          case 22:
            return _context.abrupt("return", _context.sent);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function request(_x) {
      return _request.apply(this, arguments);
    }
    return request;
  }();
  _proto.connect = /*#__PURE__*/function () {
    var _connect = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var account;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return this.signer.connect();
          case 2:
            account = _context2.sent;
            this.account = account;
            this.events.emit('connect', account);
            return _context2.abrupt("return", account);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function connect() {
      return _connect.apply(this, arguments);
    }
    return connect;
  }();
  _proto.disconnect = /*#__PURE__*/function () {
    var _disconnect = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return this.signer.disconnect();
          case 2:
            this.events.emit('disconnect');
            this.account = undefined;
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function disconnect() {
      return _disconnect.apply(this, arguments);
    }
    return disconnect;
  }();
  _proto.sendAsync = function sendAsync(args, callback) {
    this.request(args).then(function (response) {
      return callback(null, response);
    })["catch"](function (error) {
      return callback(error, undefined);
    });
  };
  _proto.enable = /*#__PURE__*/function () {
    var _enable = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var account;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return this.request({
              method: 'eth_requestAccounts'
            });
          case 2:
            account = _context4.sent;
            return _context4.abrupt("return", [(account == null ? void 0 : account.address) || '']);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function enable() {
      return _enable.apply(this, arguments);
    }
    return enable;
  }();
  _proto.isUniPassProvider = function isUniPassProvider() {
    return true;
  };
  _proto.isConnected = function isConnected() {
    return !!this.account;
  };
  _proto.getChainId = function getChainId() {
    return this.chainId;
  };
  _proto.getSigner = function getSigner() {
    return this.signer;
  };
  _proto.on = function on(event, listener) {
    this.events.on(event, listener);
  };
  _proto.once = function once(event, listener) {
    this.events.once(event, listener);
  };
  _proto.removeListener = function removeListener(event, listener) {
    this.events.removeListener(event, listener);
  };
  _proto.off = function off(event, listener) {
    this.events.off(event, listener);
  };
  return UniPassProvider;
}();

export { ARBITRUM_MAINNET, ARBITRUM_TESTNET, AVALANCHE_MAINNET, AVALANCHE_TESTNET, BSC_MAINNET, BSC_TESTNET, ETHEREUM_GOERLI, ETHEREUM_MAINNET, JsonRpcProvider, KCC_MAINNET, KCC_TESTNET, OKC_MAINNET, OKC_TESTNET, PLATON_MAINNET, PLATON_TESTNET, POLYGON_MAINNET, POLYGON_MUMBAI, RANGERS_MAINNET, RANGERS_ROBIN, SCROLL_TESTNET, SUPPORTED_CHAIN_ID, SUPPORTED_MAINNET_CHAIN_ID, SUPPORTED_TESTNET_CHAIN_ID, UniPassProvider, getChainNameByChainId, getENVByChainId, getRPCByChainId, getSignParamsMessage, getSignTypedDataParamsData, isCorrectChainId };
//# sourceMappingURL=ethereum-provider.esm.js.map
